<template>
  <div v-bind="$attrs" class="fiat-price-formatter d-inline-flex">
    <div>{{ currentCurrencyInfo.symbol }}</div>
    <FractionFormatter :fractional-price="formatFractionalPrice(fiatPrice)" />
  </div>
</template>

<script setup lang="ts">
import { defineProps, PropType } from "vue";

import { formatFractionalPrice } from "@/utils";
import { useCurrencies } from "@/composables";
import { Decimal } from "@/libs/decimal";

import FractionFormatter from "@/components/Common/Pricing/FractionFormatter.vue";

defineProps({
  fiatPrice: {
    type: Object as PropType<Decimal>,
    required: true,
  },
});

const { currentCurrencyInfo } = useCurrencies();
</script>
